import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminShell from "@/components/AdminShell";
import { Building2, Users, Gift, TrendingUp } from "lucide-react";

function Kpi({ icon: Icon, label, value, accent }) {
  return (
    <div className="bg-white border border-mr rounded-2xl p-6">
      <div className="flex items-center justify-between">
        <p className="label-eyebrow text-mr-secondary">{label}</p>
        <Icon className="h-4 w-4" style={{ color: accent }} />
      </div>
      <p className="font-display text-4xl font-bold text-mr-primary mt-3">{value}</p>
    </div>
  );
}

export default function SuperAdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/super-admin/stats").then(({ data }) => setStats(data)); }, []);

  return (
    <AdminShell title="Platform overview" scope="super">
      {stats && (
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Kpi icon={Building2} label="Clinics" value={stats.total_tenants} accent="#0F8964" />
          <Kpi icon={Users} label="Patients" value={stats.total_patients} accent="#0EA572" />
          <Kpi icon={Gift} label="Rewards" value={stats.total_rewards} accent="#0284C7" />
          <Kpi icon={TrendingUp} label="Redemptions" value={stats.total_redemptions} accent="#D9A441" />
        </div>
      )}

      <div className="mt-8 bg-white border border-mr rounded-2xl p-8">
        <h2 className="font-display text-xl font-semibold text-mr-primary mb-3">Welcome to MedRewards Platform</h2>
        <p className="text-mr-secondary max-w-2xl">
          Manage clinics and hospitals in the <strong>Clinics</strong> section. Edit the marketing site (Landing, About, Contact, Privacy, Terms) from the <strong>Content</strong> section.
        </p>
      </div>
    </AdminShell>
  );
}
